import { ProcessStatusCode } from "@/types/code.types";

export type CtgListPressInfoFilterKey =
  | "allInfo"
  | "idInfo"
  | "registryIdInfo"
  | "registryTitleInfo"
  | "companyNameInfo";

export interface CtgListPressInfoFilterType {
  key: CtgListPressInfoFilterKey;
  name: string;
  isAllInfo: boolean;
  code?: ProcessStatusCode;
}

export const CTG_LIST_INFO_FILTER: CtgListPressInfoFilterType[] = [
  {
    key: "allInfo",
    name: "All Info",
    isAllInfo: true,
  },
  {
    key: "idInfo",
    name: "ID",
    isAllInfo: false,
  },
  {
    key: "registryIdInfo",
    name: "Registry ID",
    isAllInfo: false,
  },
  {
    key: "registryTitleInfo",
    name: "Registry Title",
    isAllInfo: false,
  },
  {
    key: "companyNameInfo",
    name: "Company",
    isAllInfo: false,
  },
];

export const CTG_LIST_PRESS_INFO_FILTER_KEY = [
  "allInfo",
  "idInfo",
  "registryIdInfo",
  "registryTitleInfo",
  "companyNameInfo",
] as const;
